import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { CurrencyDollarIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import { ResultWrapper } from './helper/resultWrapper';
export const ZoneResult = ({ zone }) => {
    const { zoneName } = zone;
    const { onNavigate, onResetValues } = useContext(CustomFormContext);
    //   useEffect(() => {
    //     console.log('PAYLOAD zone', zone);
    //   }, []);
    const handleRedirect = () => {
        onNavigate(zone, zone.id, 'pricing');
        onResetValues('search');
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(CurrencyDollarIcon, { className: "size-4" }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: zoneName })] }) }));
};
//# sourceMappingURL=ZoneResults.js.map